import React, { Component } from "react";
import InstagramAiStudioStarter from "./InstagramAiStudioStarter";
import InstagramAiVideoStudioStarter from "./InstagramAiVideoStudioStarter";
import InstagramAiDesignStarter from "./InstagramAiDesignStarter";

// 통합 페이지 상단 제작 버튼 아이콘 (제공받은 SVG 원본 경로 사용)
const AiImageButtonIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
    <g clipPath="url(#unified-ai-studio-image-icon-clip)">
      <path d="M10.5254 18.9337C11.0404 18.9337 11.458 18.5135 11.458 17.9953C11.458 17.477 11.0404 17.0569 10.5254 17.0569C10.0103 17.0569 9.59277 17.477 9.59277 17.9953C9.59277 18.5135 10.0103 18.9337 10.5254 18.9337Z" fill="#333333"/>
      <path d="M16.5674 18.9337C17.0824 18.9337 17.5 18.5135 17.5 17.9953C17.5 17.477 17.0824 17.0569 16.5674 17.0569C16.0523 17.0569 15.6348 17.477 15.6348 17.9953C15.6348 18.5135 16.0523 18.9337 16.5674 18.9337Z" fill="#333333"/>
      <path d="M16.8785 23H10.2386C7.90312 23 5.99805 21.0831 5.99805 18.7331V17.9231C5.99805 15.5731 7.90312 13.6562 10.2386 13.6562H16.8785C19.214 13.6562 21.1191 15.5731 21.1191 17.9231V18.7331C21.1191 21.0831 19.214 23 16.8785 23ZM10.2386 15.172C8.7321 15.172 7.51254 16.4072 7.51254 17.915V18.7251C7.51254 20.241 8.7321 21.4681 10.2386 21.4681H16.8785C18.385 21.4681 19.6046 20.241 19.6046 18.7251V17.915C19.6046 16.3992 18.377 15.172 16.8785 15.172H10.2386Z" fill="#333333"/>
      <path d="M14.1203 12.1243H13.0044V14.0813H14.1203V12.1243Z" fill="#333333"/>
      <path d="M13.5625 20.658C12.9408 20.658 12.3589 20.4094 12.2951 20.3773C12.056 20.273 11.9444 19.9923 12.048 19.7437C12.1516 19.5031 12.4386 19.3908 12.6777 19.4951C12.6777 19.4951 13.14 19.6956 13.5705 19.6956C14.0009 19.6956 14.4553 19.5031 14.4632 19.4951C14.7024 19.3908 14.9893 19.4951 15.0929 19.7437C15.1966 19.9843 15.0929 20.273 14.8458 20.3773C14.7821 20.4094 14.1922 20.658 13.5785 20.658H13.5625Z" fill="#333333"/>
      <path d="M13.5622 12.7178C14.3282 12.7178 14.9492 12.093 14.9492 11.3222C14.9492 10.5515 14.3282 9.9267 13.5622 9.9267C12.7963 9.9267 12.1753 10.5515 12.1753 11.3222C12.1753 12.093 12.7963 12.7178 13.5622 12.7178Z" fill="#333333"/>
      <path d="M21.5494 20.7142C21.3502 20.7142 21.1589 20.6981 20.9835 20.6821L20.2422 20.634V15.934H20.8002C21.4618 15.934 23.0002 15.934 23.0002 17.2494V19.5673C23.0002 19.9763 22.8168 20.2249 22.6733 20.3613C22.3704 20.642 21.956 20.7062 21.5494 20.7062V20.7142ZM21.3581 19.5833C21.5813 19.5994 21.8364 19.5913 21.9241 19.5432L21.8922 17.2574C21.8284 17.1611 21.6052 17.113 21.3661 17.089V19.5913L21.3581 19.5833Z" fill="#333333"/>
      <path d="M5.76664 20.7142C5.36012 20.7142 4.94563 20.65 4.64273 20.3693C4.49128 20.2329 4.31592 19.9763 4.31592 19.5753V17.2574C4.31592 15.942 5.85432 15.942 6.51592 15.942H7.07389V20.634L6.33258 20.6821C6.15722 20.6981 5.96592 20.7142 5.76664 20.7142ZM5.95795 17.0809C5.71882 17.097 5.49563 17.1371 5.43983 17.2092V19.5753C5.49563 19.6073 5.74273 19.5993 5.95795 19.5833V17.0809Z" fill="#333333"/>
      <path d="M6.76285 5.87641C6.97806 6.09297 7.27299 6.21327 7.57589 6.21327C7.87879 6.21327 8.16575 6.09297 8.38096 5.87641C8.59618 5.65986 8.71575 5.37113 8.71575 5.06635C8.71575 4.76158 8.59618 4.47284 8.38096 4.25629C8.16575 4.03974 7.87879 3.91943 7.57589 3.91943C7.27299 3.91943 6.98603 4.03974 6.77082 4.25629C6.5556 4.47284 6.43604 4.76158 6.43604 5.06635C6.43604 5.21874 6.46792 5.37113 6.52372 5.50748C6.57951 5.64382 6.66719 5.77215 6.77082 5.88444L6.76285 5.87641Z" fill="#333333"/>
      <path d="M2.52246 17.8589V11.4987L5.56739 8.43493L7.53623 10.416C7.82319 10.6967 8.2058 10.8571 8.61232 10.8571C9.01884 10.8571 9.40145 10.6967 9.68841 10.416L13.9449 6.13307L17.7551 9.96682V12.8542C17.7551 13.6081 19.2775 13.6482 19.2775 12.8782V2.5319C19.2775 2.12286 19.1181 1.73788 18.8312 1.44914C18.5442 1.16041 18.1616 1 17.7551 1H2.52246C2.11594 1 1.73333 1.16041 1.44638 1.44914C1.15942 1.73788 1 2.12286 1 2.5319V17.8589C1 18.268 1.15942 18.6529 1.44638 18.9417C1.73333 19.2304 2.11594 19.3908 2.52246 19.3908H2.92101C3.86159 19.3908 3.82971 17.8669 2.96884 17.8669C2.79348 17.8669 2.52246 17.8669 2.52246 17.8669V17.8589ZM2.52246 2.5319H17.7551V7.80131L15.021 5.05031C14.7341 4.7696 14.3514 4.60919 13.9449 4.60919C13.5384 4.60919 13.1558 4.7696 12.8688 5.05031L8.61232 9.33321L6.64348 7.35217C6.35652 7.07145 5.97391 6.91105 5.56739 6.91105C5.16087 6.91105 4.77826 7.07145 4.4913 7.35217L2.52246 9.33321V2.5319Z" fill="#333333"/>
    </g>
    <defs>
      <clipPath id="unified-ai-studio-image-icon-clip">
        <rect width="22" height="22" fill="white" transform="translate(1 1)"/>
      </clipPath>
    </defs>
  </svg>
);

const AiVideoButtonIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
    <path d="M15.6662 12.923L11.1662 9.92299C11.0533 9.84761 10.9219 9.80433 10.7863 9.79775C10.6506 9.79118 10.5157 9.82157 10.396 9.88567C10.2763 9.94977 10.1762 10.0452 10.1064 10.1617C10.0367 10.2783 9.99991 10.4115 10 10.5474V16.5474C9.99991 16.6832 10.0367 16.8165 10.1064 16.933C10.1762 17.0495 10.2763 17.145 10.396 17.2091C10.5157 17.2732 10.6506 17.3035 10.7863 17.297C10.9219 17.2904 11.0533 17.2471 11.1662 17.1717L15.6662 14.1717C15.7691 14.1033 15.8535 14.0105 15.9118 13.9015C15.9702 13.7926 16.0007 13.6709 16.0007 13.5474C16.0007 13.4238 15.9702 13.3021 15.9118 13.1932C15.8535 13.0843 15.7691 12.9915 15.6662 12.923ZM11.5 15.1458V11.9536L13.8981 13.5474L11.5 15.1458Z" fill="#333333"/>
    <path d="M18.7632 3H17.5651H16.2499H15.151H13.9014H11.5287H10.4569H8.9657H7.81931H5.23677C4.64354 3 4.07461 3.23955 3.65514 3.66595C3.23566 4.09235 3 4.67067 3 5.27368V18.7263C3 19.3293 3.23566 19.9077 3.65514 20.3341C4.07461 20.7605 4.64354 21 5.23677 21H18.7632C19.3565 21 19.9254 20.7605 20.3449 20.3341C20.7643 19.9077 21 19.3293 21 18.7263V5.27368C21 4.67067 20.7643 4.09235 20.3449 3.66595C19.9254 3.23955 19.3565 3 18.7632 3ZM19.5088 18.7263C19.5088 18.9273 19.4303 19.1201 19.2904 19.2622C19.1506 19.4044 18.961 19.4842 18.7632 19.4842H5.23677C5.03903 19.4842 4.84939 19.4044 4.70956 19.2622C4.56974 19.1201 4.49118 18.9273 4.49118 18.7263V5.27368C4.49118 5.07268 4.56974 4.8799 4.70956 4.73777C4.84939 4.59564 5.03903 4.51579 5.23677 4.51579H8.21914C8.34192 4.51587 9.18311 4.51579 9.27556 4.51579C9.46196 4.51579 10.8075 4.51579 9.71032 4.51579H11.9471H14.246H16.0265H16.514H17.1662H18.7632C18.961 4.51579 19.1506 4.59564 19.2904 4.73777C19.4303 4.8799 19.5088 5.07268 19.5088 5.27368V18.7263Z" fill="#333333"/>
    <path d="M4.5 7.5H20" strokeWidth="1.5" stroke="#333333"/>
    <path d="M7 4L9 7.4641" strokeWidth="1.5" strokeLinecap="round" stroke="#333333"/>
    <path d="M11 4L13 7.4641" strokeWidth="1.5" strokeLinecap="round" stroke="#333333"/>
    <path d="M15 4L17 7.4641" strokeWidth="1.5" strokeLinecap="round" stroke="#333333"/>
  </svg>
);

const DesignButtonIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
    <path d="M20.25 3.75H3.75C3.35218 3.75 2.97064 3.90804 2.68934 4.18934C2.40804 4.47064 2.25 4.85218 2.25 5.25V18.75C2.25 19.1478 2.40804 19.5294 2.68934 19.8107C2.97064 20.092 3.35218 20.25 3.75 20.25H20.25C20.6478 20.25 21.0294 20.092 21.3107 19.8107C21.592 19.5294 21.75 19.1478 21.75 18.75V5.25C21.75 4.85218 21.592 4.47064 21.3107 4.18934C21.0294 3.90804 20.6478 3.75 20.25 3.75ZM20.25 5.25V9H3.75V5.25H20.25ZM3.75 10.5H9V18.75H3.75V10.5ZM20.25 18.75H10.5V10.5H20.25V18.75Z" fill="#333333"/>
  </svg>
);

/**
 * AI 스튜디오 통합 진입점.
 * - 상단 레이아웃/명칭/탭/접기 UI: RoboMD_Unified_AI_Studio_v12.html
 * - 추천/갤러리 카드와 모든 기존 작업·팝업 기능: 각각의 기존 Starter JS
 * - 방문한 탭의 인스턴스를 유지하여 데이터/펼침 상태와 작업 이력을 보존합니다.
 *
 * 기존 페이지 라우트에서 이 컴포넌트 하나만 렌더링하면 됩니다.
 */
class InstagramAiStudioUnifiedStarter extends Component {
  constructor(props) {
    super(props);
    const search = typeof window !== "undefined" ? window.location.search : "";
    const initialTab = new URLSearchParams(search).get("open_ai_video_studio") === "Y" ? "video" : "image";

    this.studioRefs = { image: null, video: null, design: null };
    this.state = {
      activeTab: initialTab,
      visitedTabs: { [initialTab]: true },
      viewportWidth: typeof window === "undefined" ? 1440 : window.innerWidth,
    };
  }

  componentDidMount() {
    window.addEventListener("resize", this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  handleResize = () => {
    if (this.state.viewportWidth !== window.innerWidth) {
      this.setState({ viewportWidth: window.innerWidth });
    }
  };

  getCollapsedCount = (tab) => {
    const width = this.state.viewportWidth;
    if (tab === "video") {
      if (width <= 480) return 1;
      if (width <= 768) return 2;
      if (width <= 1100) return 3;
      if (width <= 1360) return 4;
      if (width <= 1600) return 5;
      return 6;
    }
    if (width <= 768) return 2;
    if (width <= 1024) return 3;
    if (width <= 1280) return 4;
    return 6;
  };

  changeTab = (tab, onChanged) => {
    this.setState((prev) => ({
      activeTab: tab,
      visitedTabs: { ...prev.visitedTabs, [tab]: true },
    }), () => {
      const instance = this.studioRefs[tab];
      if (instance && typeof instance.checkNeedLoadMore === "function") {
        instance.checkNeedLoadMore();
      }
      if (typeof onChanged === "function") onChanged(instance);
    });
  };

  openNew = (tab) => {
    const method = { image: "handleCreateImage", video: "handleCreateVideo", design: "handleCreateDesign" }[tab];
    this.changeTab(tab, (instance) => {
      if (instance && typeof instance[method] === "function") instance[method]();
    });
  };

  renderStyle() {
    return `
      #page-wrapper.unified-ai-studio {
        padding: 72px 0 0 220px;
        width: 100%;
        max-width: 100%;
        min-height: 100vh;
        box-sizing: border-box;
        background: #fff;
      }
      .unified-ai-studio, .unified-ai-studio * { box-sizing: border-box; }
      .unified-ai-studio .unified-shell {
        width: 100%; min-height: calc(100vh - 72px);
        background: linear-gradient(180deg, #eaf4f5 0%, #f4f7f8 140px, #fff 270px);
        color: #111827; font-family: 'Noto Sans KR', sans-serif;
        letter-spacing: -0.3px;
      }
      .unified-ai-studio .unified-inner {
        padding: 56px 40px 60px; max-width: 1600px; margin: 0 auto; width: 100%;
      }
      .unified-ai-studio .unified-hero { text-align: center; display: flex; flex-direction: column; align-items: center; gap: 10px; }
      .unified-ai-studio .unified-hero h2 {
        font-size: 28px; font-weight: 800; color: #0A1A2F; margin: 0; line-height: 1.4;
      }
      .unified-ai-studio .unified-hero p { font-size: 15px; font-weight: 400; color: #4b5563; margin: 0; }
      .unified-ai-studio .unified-hero-actions {
        display: flex; align-items: center; justify-content: center;
        flex-wrap: wrap; gap: 20px; margin: 24px 0 32px;
      }
      .unified-ai-studio .unified-hero-button {
        display: inline-flex; align-items: center; justify-content: center; gap: 10px;
        background: #00e2e6; color: #0A1A2F; border: none;
        padding: 16px 32px; border-radius: 12px;
        font-size: 16px; font-weight: 800; cursor: pointer;
        box-shadow: 0 4px 16px rgba(0, 226, 230, .25);
        transition: transform .2s, background .2s, box-shadow .2s;
      }
      .unified-ai-studio .unified-hero-button:hover {
        background: #00bfc2; transform: translateY(-3px);
        box-shadow: 0 8px 20px rgba(0, 226, 230, .4);
      }
      .unified-ai-studio .unified-hero-button i { font-size: 18px; }
      .unified-ai-studio .unified-tab-bar {
        display: flex; align-items: stretch; justify-content: center; gap: 24px;
        margin-bottom: 24px; border-bottom: 2px solid #e5e7eb;
      }
      .unified-ai-studio .unified-tab {
        background: transparent; color: #9ca3af; border: none;
        border-bottom: 4px solid transparent; padding: 16px 32px;
        margin-bottom: -2px; font-size: 17px; font-weight: 600;
        cursor: pointer; white-space: nowrap; transition: color .2s;
      }
      .unified-ai-studio .unified-tab:hover { color: #0A1A2F; }
      .unified-ai-studio .unified-tab.active { color: #0A1A2F; font-weight: 800; border-bottom-color: #00bfc2; }
      .unified-ai-studio .studio-pane[hidden] { display: none !important; }
      .unified-ai-studio .studio-pane .instagram-ai-studio-list,
      .unified-ai-studio .studio-pane .ai-video-studio-starter,
      .unified-ai-studio .studio-pane .instagram-ai-design-list {
        background: transparent !important; min-height: 0 !important;
        overflow: visible !important; width: 100%;
      }
      .unified-ai-studio .studio-pane .main-content {
        background: transparent !important; width: 100%; margin: 0 !important;
        min-height: 0 !important;
      }
      .unified-ai-studio .studio-pane > .instagram-product-automation-list > .main-content > .content-inner {
        padding: 0 !important; margin: 0 !important; max-width: none !important;
        display: flex; flex-direction: column; gap: 40px;
      }
      .unified-ai-studio .studio-pane .recommend-section,
      .unified-ai-studio .studio-pane .gallery-section { scroll-margin-top: 110px; }
      /* 그리드 상단 헤더: AI스튜디오 개선.html의 시각 스타일만 적용 */
      .unified-ai-studio .studio-pane .unified-section-header {
        display: flex !important; justify-content: space-between !important;
        align-items: center !important; gap: 16px;
        margin: 0 0 16px !important; padding: 0 0 8px !important;
        border: none !important; background: transparent !important;
      }
      .unified-ai-studio .studio-pane .unified-section-title {
        display: flex; align-items: center; min-width: 0;
      }
      .unified-ai-studio .studio-pane .unified-section-title h3 {
        display: block; font-size: 20px !important; font-weight: 700 !important;
        color: #111827 !important; margin: 0 !important; line-height: 1.4;
      }
      .unified-ai-studio .studio-pane .unified-section-link {
        display: inline-flex; align-items: center; justify-content: flex-end; gap: 4px;
        flex-shrink: 0; padding: 0; margin: 0;
        background: transparent; border: none; border-radius: 0;
        color: #4b5563; font-size: 14px; font-weight: 500;
        font-family: inherit; line-height: 1.5; text-decoration: none;
        transition: color .2s;
      }
      .unified-ai-studio .studio-pane button.unified-section-link { cursor: pointer; }
      .unified-ai-studio .studio-pane button.unified-section-link:hover { color: #0A1A2F; }
      .unified-ai-studio .studio-pane .unified-section-count-num {
        color: #00bfc2; font-size: 15px; font-weight: 700;
        margin: 0 2px;
      }
      .unified-ai-studio .studio-pane .unified-section-link i {
        font-size: 13px; margin-left: 2px; margin-top: 1px;
      }
      /* 하단 접기 버튼은 v3의 .unified-toggle-button 스타일/동작 유지 */
      .unified-ai-studio .studio-pane .unified-toggle-button {
        display: inline-flex; align-items: center; justify-content: center; gap: 6px;
        flex-shrink: 0; border: 1px solid #e5e7eb; border-radius: 20px;
        padding: 8px 18px; background: #fff; color: #4b5563;
        font-size: 13px; font-weight: 700; line-height: 1.4;
        cursor: pointer; transition: border-color .2s, color .2s, background .2s;
      }
      .unified-ai-studio .studio-pane .unified-toggle-button:hover {
        background: #f9fafb; border-color: #d1d5db; color: #0A1A2F;
      }
      .unified-ai-studio .studio-pane .unified-bottom-fold {
        display: flex; justify-content: center; padding: 16px 0 4px;
      }
      .unified-ai-studio .studio-pane .gallery-section { margin-top: 8px; }
      @media (max-width: 1100px) {
        #page-wrapper.unified-ai-studio { padding-left: 0; }
      }
      @media (max-width: 1024px) {
        .unified-ai-studio .unified-inner { padding: 32px 16px 48px; }
        .unified-ai-studio .unified-hero-actions { gap: 12px; margin: 16px 0 24px; }
        .unified-ai-studio .unified-tab-bar { gap: 10px; }
        .unified-ai-studio .unified-tab { padding: 12px 16px; font-size: 15px; }
      }
      @media (max-width: 768px) {
        .unified-ai-studio .unified-hero h2 { font-size: 24px; }
        .unified-ai-studio .unified-hero p { font-size: 13px; }
        .unified-ai-studio .unified-hero-actions { flex-direction: column; width: 100%; max-width: 320px; }
        .unified-ai-studio .unified-hero-button { width: 100%; }
        .unified-ai-studio .unified-tab-bar { overflow-x: auto; justify-content: flex-start; }
        .unified-ai-studio .unified-tab { padding: 12px; font-size: 14px; }
        .unified-ai-studio .studio-pane .unified-section-header { gap: 10px; }
        .unified-ai-studio .studio-pane .unified-toggle-button { font-size: 12px; padding: 7px 10px; }
        .unified-ai-studio .studio-pane .unified-section-title h3 { font-size: 18px !important; }
        .unified-ai-studio .studio-pane .unified-section-link { font-size: 12px; }
        .unified-ai-studio .studio-pane .unified-section-count-num { font-size: 13px; }
      }
    `;
  }

  render() {
    const { activeTab, visitedTabs } = this.state;
    return (
      <div id="page-wrapper" className="unified-ai-studio">
        <style>{this.renderStyle()}</style>
        <main className="unified-shell">
          <div className="unified-inner">
            <section className="unified-hero">
              <h2>AI 스튜디오</h2>
              <p>아이디어와 사진으로 AI 이미지와 디자인을 만들고, 자유롭게 수정하거나 다운로드하세요.</p>
              <div className="unified-hero-actions">
                <button className="unified-hero-button" type="button" onClick={() => this.openNew("image")}>
                  <AiImageButtonIcon /> AI 이미지 만들기
                </button>
                <button className="unified-hero-button" type="button" onClick={() => this.openNew("video")}>
                  <AiVideoButtonIcon /> AI 동영상 만들기
                </button> 
                <button className="unified-hero-button" type="button" onClick={() => this.openNew("design")}>
                  <DesignButtonIcon /> 템플릿 디자인 만들기
                </button>
              </div>
            </section>

            <nav className="unified-tab-bar" role="tablist" aria-label="AI 스튜디오 도구 유형">
              {[
                { key: "image", label: "AI 이미지" },
                { key: "video", label: "AI 동영상" },
                { key: "design", label: "템플릿 디자인" },
              ].map((tab) => (
                <button key={tab.key} id={"unified-tab-" + tab.key} role="tab" type="button"
                  className={"unified-tab" + (activeTab === tab.key ? " active" : "")}
                  aria-selected={activeTab === tab.key}
                  aria-controls={"unified-pane-" + tab.key}
                  onClick={() => this.changeTab(tab.key)}>
                  {tab.label}
                </button>
              ))}
            </nav>

            <div className="studio-pane" id="unified-pane-image" role="tabpanel" aria-labelledby="unified-tab-image" hidden={activeTab !== "image"}>
              {visitedTabs.image ? <InstagramAiStudioStarter {...this.props} ref={(instance) => { this.studioRefs.image = instance; }}
                embedded active={activeTab === "image"} collapsedCount={this.getCollapsedCount("image")} /> : null}
            </div>
            <div className="studio-pane" id="unified-pane-video" role="tabpanel" aria-labelledby="unified-tab-video" hidden={activeTab !== "video"}>
              {visitedTabs.video ? <InstagramAiVideoStudioStarter {...this.props} ref={(instance) => { this.studioRefs.video = instance; }}
                embedded active={activeTab === "video"} collapsedCount={this.getCollapsedCount("video")} /> : null}
            </div>
            <div className="studio-pane" id="unified-pane-design" role="tabpanel" aria-labelledby="unified-tab-design" hidden={activeTab !== "design"}>
              {visitedTabs.design ? <InstagramAiDesignStarter {...this.props} ref={(instance) => { this.studioRefs.design = instance; }}
                embedded active={activeTab === "design"} collapsedCount={this.getCollapsedCount("design")} /> : null}
            </div>
          </div>
        </main>
      </div>
    );
  }
}

export default InstagramAiStudioUnifiedStarter;
